import React from "react";
import "@Styles/mandate.css";
import Heading from "../Common/MainHeading";
import { HEADING_ASSIGNINGNBFC } from "../Common/constant";
import disburseloader from "@Images/NewUI/disburseLoader.png";

const DisbursingNbfc = (props) => {
  return (
    <div className="main_div">
      <div className="container">
        <div className="pb-4">
          <Heading
            headingText={HEADING_ASSIGNINGNBFC}
            backprops={"/DummyDashboard"}
            history={props.history}
          />
          <div className="wrapper-content e-sign">
            <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-4 pb-5">
                  <img
                    src={disburseloader}
                    alt="transfer"
                    style={{ width: "100%", margin: "110px 0px" }}
                  />
                  <p>
                    Disbursal in 24 hours 
                    <br />
                    <span className="paymecolour">23:54:00</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisbursingNbfc;
